import { FieldParm } from '@api/models'
import { Form, Grid, Input } from '@components/common'
import { FIELD_PARM_ID } from '@constants'

import { useForm } from 'react-hook-form'

interface FieldPrefsFormProps {
  initialValues: FieldParm
  onSubmit: (values: FieldParm) => Promise<void>
  existingNames: string[]
}

const FieldPrefsForm = ({
  initialValues,
  onSubmit,
  existingNames,
}: FieldPrefsFormProps) => {
  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
    setError,
  } = useForm<FieldParm>({
    mode: 'onBlur',
    defaultValues: initialValues,
  })

  async function onSubmitWithServerErrors(values: FieldParm): Promise<void> {
    try {
      await onSubmit({ ...values, PM_PMT: values.PM_PMT?.trim() })
    } catch (err: any) {
      const msg =
        err?.data?.validation_errors?.[0] ??
        err?.response?.data?.validation_errors?.[0] ??
        'There was an error'
      setError('PM_PMT' as any, { type: 'server', message: msg } as any)
    }
  }

  return (
    <Form id={FIELD_PARM_ID} onSubmit={handleSubmit(onSubmitWithServerErrors)} noValidate>
      <Grid>
        <Grid.Item>
          <Input
            {...register('PM_PMT', {
              validate: (value: string) => {
                const normalized = (value ?? '').trim().toLowerCase()
                if (normalized === '') return true
                const exists = existingNames.some(
                  name => (name ?? '').trim().toLowerCase() === normalized
                )
                return exists ? 'A field with this label already exists' : true
              },
            })}
            disabled={isSubmitting}
            error={errors.PM_PMT !== undefined}
            errorMsg={errors.PM_PMT?.message}
            label="Field label"
          />
        </Grid.Item>
      </Grid>
    </Form>
  )
}

export default FieldPrefsForm
